import React from 'react';
import { Notifications } from '@mui/icons-material';
import { useNotificationSubscriptions } from '../services/api';

// Read-only indicator showing if user is subscribed to a list
// Used in dropdowns - not interactive
const SubscriptionIndicator = ({ listId, userEmail }) => {
  const { data: subscribedLists = [] } = useNotificationSubscriptions(userEmail);
  const isSubscribed = subscribedLists.includes(listId);

  if (!isSubscribed) return null;

  return (
    <span className="ml-3" style={{ color: '#D4AF37' }} title="You're subscribed to notifications for this list">
      <Notifications style={{ fontSize: 18 }} />
    </span>
  );
};

export default SubscriptionIndicator;
